import React from 'react'
import { createContext, useContext } from 'react'
import microcopyData from '../data/microcopy-data.json'

const MicroCopyContext = createContext()

export const MicroCopyContextProvider = ({ children }) => {
  return (
    <MicroCopyContext.Provider value={microcopyData.data}>{children}</MicroCopyContext.Provider>
  )
}

export const useMicroCopyData = () => useContext(MicroCopyContext)
